<div
  class="bookable-installation"
  [attr.data-at-disabled]="isDisabled"
  [ngClass]="{
    selected: isSelected,
    disabled: isDisabled
  }"
>
  <mat-checkbox
    #checkboxElement
    data-at-device-selection-checkbox
    [attr.data-at-checked]="isSelected"
    [attr.data-at-disabled]="isDisabled"
    gtm="onToggle"
    gtmAction="Booking Devices"
    gtmCategory="booking"
    [checked]="isSelected"
    [disabled]="isDisabled"
    (change)="onInstallationSelect(checkboxElement)"
    color="primary"
  ></mat-checkbox>
  <div class="entry-row">
    <div class="entry-name" data-at-device-name>
      <div class="name" [class.spaced]="device.vin">
        <span>
          {{ deviceTitle }}
          <mat-icon
            class="name-icon"
            matTooltipClass="data-at-not-bookable-reason"
            data-at-info-icon
            *ngIf="isDisabled"
            [matTooltip]="tooltipForNonBookableInstallation | translate"
            >info_outline</mat-icon
          ></span
        >
      </div>
      <div data-at-boiler-serial class="entry-info">{{ device.vin }}</div>
    </div>
    <div data-at-owner class="entry-owner entry-info">{{ device.ownerName }}</div>
    <div data-at-address class="entry-address entry-info">
      {{ device.location }}
    </div>
  </div>
</div>
